import { List, Skeleton } from "antd";
import { genArray } from "Admin/Utils/ArrayGenerator";
import React from "react";

const LoadingListEntityProfile = ({
  isLoading,
  component,
  componentNum,
  rows = 2,
  avatar = true,
}) => {
  return isLoading ? (
    <List
      grid={{ gutter: 10, column: 1 }}
      dataSource={genArray(componentNum)}
      renderItem={(index) => {
        return (
          <List.Item key={index}>
            <Skeleton
              avatar={avatar}
              paragraph={{
                rows: rows,
              }}
              active
            />
          </List.Item>
        );
      }}
    />
  ) : (
    component
  );
};

export default LoadingListEntityProfile;
